export function moveLeagueMember<T>(members: T[], index: number, direction: -1 | 1): T[] {
  const destination = index + direction;
  if (index < 0 || index >= members.length || destination < 0 || destination >= members.length) return members;
  const result = [...members];
  [result[index], result[destination]] = [result[destination], result[index]];
  return result;
}
